import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Activate.css';

const Activate = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [activationCode, setActivationCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.verifyActivationCode(activationCode, email);
      if (response.data.success) {
        // Navigate to set password page with verification token
        navigate('/set-password', {
          state: {
            token: response.data.data.verificationToken,
            agencyName: response.data.data.agencyName,
            email: response.data.data.email
          }
        });
      } else {
        setError(response.data.message || 'Verification failed');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid activation code or email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activate-page">
      <div className="activate-card">
        <div className="activate-logo">
          <div className="logo-icon">C</div>
        </div>

        <h1 className="activate-title">CITIZENOS</h1>
        <p className="activate-subtitle">ACTIVATE YOUR ACCOUNT</p>

        <form onSubmit={handleSubmit} className="activate-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">EMAIL ADDRESS</label>
            <input
              type="email"
              id="email"
              className="form-input"
              placeholder="agency@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="activationCode" className="form-label">ACTIVATION CODE</label>
            <input
              type="text"
              id="activationCode"
              className="form-input"
              placeholder="ONCN-XXXXXXXX"
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value.toUpperCase())}
              required
              disabled={loading}
              maxLength={13}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="activate-button"
            disabled={loading}
          >
            {loading ? 'VERIFYING...' : 'VERIFY & CONTINUE'}
          </button>
        </form>

        <div className="activate-footer">
          <Link to="/login" className="login-link">
            Already activated? Login here
          </Link>
        </div>

        <p className="activate-footer-text">
          SECURED BY CITIZENOS VAULT ENCRYPTION
        </p>
      </div>
    </div>
  );
};

export default Activate;
